import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MessageCircleIcon } from 'lucide-react';
import { Logo } from './Logo';
import { SocialFeed } from './SocialFeed';
import { SocialIcon } from './SocialIcon';
import { NewsletterForm } from './NewsletterForm';
import { StatusBadge } from '../ui/StatusBadge';
import { destinations } from '../../data/destinations';
import { aboutLinks, policyLinks, priceListLinks } from '../../data/navigation';
import { contact } from '../../data/contact';
import { socialLinks } from '../../data/social';
import { destinationPath } from '../../utils/paths';
const linkClass = 'type-card-desc text-white/85 transition-colors duration-150 hover:text-white';
export function Footer() {
  return <>
      <SocialFeed data-id="element-546" data-mp="3izw1hlh5po43" />
      <div className="w-full bg-white pt-6" data-id="element-547" data-mp="3e2w6c5lui5rr">
        <footer className="w-full rounded-t-[28px] bg-body text-white md:rounded-t-[48px]" data-id="element-548" data-mp="3e1ulj9f124wu">
          <div className="mx-auto grid max-w-content gap-12 px-5 py-16 md:px-8 md:py-20 lg:grid-cols-12" data-id="element-549" data-mp="394ubyoiyyk0z">
            <div className="lg:col-span-5" data-id="element-550" data-mp="2kcbcbi3xe8ow">
              <Logo variant="white" className="h-11" data-id="element-551" data-mp="2kb9zp979he52" />
              <ul className="mt-6 flex flex-wrap gap-2" aria-label="ES World on social media" data-id="element-552" data-mp="2p4mpvnrl9szx">
                {socialLinks.map(social => <li key={social.platform} data-id="element-553" data-mp="2balosnd5ztwe">
                    <a href={social.href} target="_blank" rel="noreferrer" aria-label={social.label} className="flex h-9 w-9 items-center justify-center rounded-full border-2 border-white text-white transition-colors duration-150 hover:bg-white hover:text-body" data-id="element-554" data-mp="2gckq7rpcggqp">
                      <SocialIcon platform={social.platform} data-id="element-555" data-mp="2z0y3qi6tuqwh" />
                    </a>
                  </li>)}
              </ul>
              <p className="mt-5 max-w-sm type-card-desc text-white/85" data-id="element-556" data-mp="1ipu595j1g82f">
                One English language school with campuses in several locations. The same method and support, wherever you study.
              </p>
              <NewsletterForm data-id="element-557" data-mp="zj4irxdevhqi" />
              <p className="mt-5 type-fine text-white/80" data-id="element-558" data-mp="zk75ru7m5015">© ES World {new Date().getFullYear()}. All Rights Reserved.</p>
            </div>

            <div className="grid grid-cols-2 gap-10 md:grid-cols-3 lg:col-span-7" data-id="element-559" data-mp="uqbaiziqhr9o">
              <FooterGroup title="Destinations" data-id="element-560" data-mp="pst9dvaykgc8">
                {destinations.map(d => <li key={d.slug} data-id="element-561" data-mp="kvt61s5htrot">
                    <Link to={destinationPath(d, d.yearRound ? 'year-round' : 'seasonal')} className={linkClass} data-id="element-562" data-mp="fv53qabtdofa">
                      {d.name}
                    </Link>
                  </li>)}
              </FooterGroup>

              <FooterGroup title="Resources" data-id="element-563" data-mp="6vidmkojc51j">
                <li data-id="element-564" data-mp="6wjmcii2wfg3">
                  <Link to="/contact" className={linkClass} data-id="element-565" data-mp="267b2fu166436">
                    Help Center
                  </Link>
                </li>
                {[...priceListLinks, ...policyLinks].map(link => <li key={link.to} data-id="element-566" data-mp="28sisd18c81g8">
                    <Link to={link.to} className={linkClass} data-id="element-567" data-mp="28rhhoxv8hgz1">
                      {link.label}
                    </Link>
                  </li>)}
              </FooterGroup>

              <div className="col-span-2 md:col-span-1" data-id="element-568" data-mp="2ij50ybhmzrpf">
                <FooterGroup title="Company" data-id="element-569" data-mp="2ngnfchefaz4t">
                  {aboutLinks.map(link => <li key={link.to} data-id="element-570" data-mp="1pt4y0i6p4op7">
                      <Link to={link.to} className={`${linkClass} inline-flex items-center gap-2`} data-id="element-571" data-mp="1pugad6e7j4rx">
                        {link.label}
                        {link.comingSoon ? <StatusBadge data-id="element-572" data-mp="1zrcc8t9losni">Coming soon</StatusBadge> : null}
                      </Link>
                    </li>)}
                </FooterGroup>
                <ul className="mt-8 space-y-5" data-id="element-573" data-mp="23qtfrh5gvfq1">
                  <li data-id="element-574" data-mp="3b79a56zf2mwv">
                    <a href={contact.emailLink} className="group flex items-start gap-3" data-id="element-575" data-mp="3b5pu9hhoadvm">
                      <MailIcon className="mt-0.5 h-7 w-7 shrink-0 text-white" strokeWidth={1.5} aria-hidden="true" data-id="element-576" data-mp="3f71o5z7kxl9m" />
                      <span data-id="element-577" data-mp="3drfng59x7pq3">
                        <span className="block type-small text-white/80" data-id="element-578" data-mp="3dsqr853d8xh7">Email Address</span>
                        <span className="block break-all type-list text-white group-hover:underline" data-id="element-579" data-mp="38u75a4orvlou">{contact.email}</span>
                      </span>
                    </a>
                  </li>
                  <li data-id="element-580" data-mp="3is3bqj6rlsgm">
                    <a href={contact.whatsappLink} target="_blank" rel="noreferrer" className="group flex items-start gap-3" data-id="element-581" data-mp="k4755payjpn">
                      <MessageCircleIcon className="mt-0.5 h-7 w-7 shrink-0 text-white" strokeWidth={1.5} aria-hidden="true" data-id="element-582" data-mp="3rpni26jhiey3" />
                      <span data-id="element-583" data-mp="a9nno4pjm1hc">
                        <span className="block type-small text-white/80" data-id="element-584" data-mp="5b43o9uiezrm">Emergency Calls</span>
                        <span className="block type-list text-white group-hover:underline" data-id="element-585" data-mp="5dgl8lwcv845">{contact.whatsappDisplay}</span>
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>;
}
function FooterGroup({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-586" data-mp="oww71st09d4e">
      <h2 className="type-h5 text-white" data-id="element-587" data-mp="ox5w9e687g91">{title}</h2>
      <ul className="mt-5 space-y-3" data-id="element-588" data-mp="owmh257yn5yp">{children}</ul>
    </div>;
}